import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.webp'


const _hoisted_1 = {
  id: "app",
  class: "our-bg-color"
}
const _hoisted_2 = {
  key: 0,
  id: "mainNavbar",
  class: "tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-slate-200/70 tw-bg-white/80 tw-backdrop-blur-lg tw-shadow-sm tw-shadow-slate-900/5"
}
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-gap-1 tw-px-0 tw-py-3 md:tw-flex-row md:tw-items-center md:tw-justify-end md:tw-gap-2 md:tw-px-0 md:tw-py-0" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "tw-hidden tw-min-w-max tw-pt-1 md:tw-absolute md:tw-left-0 md:tw-top-full md:tw-block md:tw-opacity-0 md:tw-pointer-events-none md:group-hover:tw-opacity-100 md:group-hover:tw-pointer-events-auto" }
const _hoisted_7 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-lg tw-shadow-slate-900/10 tw-p-1" }
const _hoisted_8 = { class: "tw-flex tw-flex-col" }
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = { class: "md:tw-hidden tw-pl-3" }
const _hoisted_11 = ["href", "onClick"]
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = ["href", "onClick"]
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = { class: "tw-relative tw-group" }
const _hoisted_18 = { class: "tw-flex tw-items-center tw-gap-3" }
const _hoisted_19 = { class: "tw-hidden sm:tw-flex tw-items-stretch tw-h-11 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 hover:tw-bg-white tw-cursor-pointer tw-overflow-visible" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "tw-flex tw-flex-col tw-leading-tight tw-text-left tw-cursor-pointer" }
const _hoisted_22 = { class: "tw-text-xs tw-font-semibold tw-text-slate-900" }
const _hoisted_23 = {
  key: 0,
  class: "tw-text-[11px] tw-text-slate-600 tw-cursor-pointer tw-transition-colors hover:tw-text-slate-900"
}
const _hoisted_24 = { class: "tw-relative tw-group/gear" }
const _hoisted_25 = ["href", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "tw-hidden tw-min-w-max tw-pt-1 md:tw-absolute md:tw-right-0 md:tw-top-full md:tw-block md:tw-opacity-0 md:tw-pointer-events-none md:group-hover/gear:tw-opacity-100 md:group-hover/gear:tw-pointer-events-auto"
}
const _hoisted_27 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-lg tw-shadow-slate-900/10 tw-p-1" }
const _hoisted_28 = { class: "tw-flex tw-flex-col" }
const _hoisted_29 = ["href", "onClick"]
const _hoisted_30 = {
  key: 0,
  class: "md:tw-hidden tw-pl-3"
}
const _hoisted_31 = ["href", "onClick"]
const _hoisted_32 = ["href", "onClick"]
const _hoisted_33 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToastHost = _resolveComponent("ToastHost")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToastHost),
    (
      !_ctx.$route.fullPath.includes('print') &&
      !_ctx.$route.fullPath.includes('status')
    )
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("div", {
            class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-px-3 sm:tw-px-5 tw-py-2",
            "on:logIn": _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logIn && _ctx.logIn(...args)))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tw-flex tw-items-stretch tw-h-16" }, [
              _createElementVNode("a", {
                class: "tw-flex tw-items-center",
                href: "/"
              }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Contrak",
                  class: "tw-h-full tw-w-auto tw-object-contain"
                })
              ])
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white md:tw-hidden",
              "aria-expanded": Boolean(_ctx.isNavOpen),
              "aria-label": "Toggle navigation",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isNavOpen = !_ctx.isNavOpen))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "tw-h-5 tw-w-5" }, "☰", -1)
            ]))], 8, _hoisted_3),
            _createElementVNode("ul", {
              class: _normalizeClass(["tw-absolute tw-left-0 tw-right-0 tw-top-full tw-z-50 tw-border-b tw-border-slate-200/70 tw-bg-white/95 tw-backdrop-blur md:tw-static md:tw-border-0 md:tw-bg-transparent", _ctx.isNavOpen ? 'tw-block' : 'tw-hidden md:tw-flex'])
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.isLoggedIn || _ctx.canAccessAdmin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/tracking",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass(["tw-relative tw-group", { 'uk-active': isActive }])
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Tracking", 8, _hoisted_5),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("ul", _hoisted_8, [
                                      _createVNode(_component_router_link, {
                                        to: "/archived",
                                        custom: ""
                                      }, {
                                        default: _withCtx(({ href, navigate }) => [
                                          _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                              href: href,
                                              onClick: navigate,
                                              class: "uk-navbar-nav_a"
                                            }, "Archived", 8, _hoisted_9)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_router_link, {
                                    to: "/archived",
                                    custom: ""
                                  }, {
                                    default: _withCtx(({ href, navigate }) => [
                                      _createElementVNode("a", {
                                        href: href,
                                        onClick: navigate,
                                        class: "uk-navbar-nav_a tw-inline-flex tw-w-full"
                                      }, "Archived", 8, _hoisted_11)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: "/orders",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass({ 'uk-active': isActive })
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Orders", 8, _hoisted_12)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 2,
                            to: "/dispatch",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass({ 'uk-active': isActive })
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Dispatch", 8, _hoisted_13)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 3,
                            to: "/customers",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass({ 'uk-active': isActive })
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Contacts", 8, _hoisted_14)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 4,
                            to: "/billing",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass({ 'uk-active': isActive })
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Billing", 8, _hoisted_15)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 5,
                            to: "/reports",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass({ 'uk-active': isActive })
                              }, [
                                _createElementVNode("a", {
                                  href: href,
                                  onClick: navigate,
                                  class: "uk-navbar-nav_a"
                                }, "Reports", 8, _hoisted_16)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 6,
                            to: "/profile",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate, isActive }) => [
                              _createElementVNode("li", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                      class: "tw-flex tw-items-center tw-gap-3 tw-h-full tw-px-3 hover:tw-bg-slate-900/5 tw-rounded-l-xl tw-transition-colors",
                                      onClick: navigate
                                    }, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "user",
                                        class: "tw-h-4 tw-w-4 tw-text-slate-600 tw-cursor-pointer tw-transition-colors hover:tw-text-slate-900"
                                      }),
                                      _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.username() || 'User'), 1),
                                        (_ctx.userEmail())
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.userEmail()), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_20),
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tw-my-2.5 tw-w-px tw-bg-slate-200/80" }, null, -1)),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("a", {
                                        href: href,
                                        onClick: navigate,
                                        class: "tw-flex tw-items-center tw-justify-center tw-h-full tw-px-4 tw-cursor-pointer tw-rounded-r-xl tw-transition-colors hover:tw-bg-slate-900/5",
                                        "aria-label": "Settings",
                                        title: "Settings"
                                      }, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "gear",
                                          class: "tw-h-4 tw-w-4 tw-text-slate-700 tw-cursor-pointer tw-transition-colors hover:tw-text-slate-900"
                                        })
                                      ], 8, _hoisted_25),
                                      (_ctx.canAccessAdmin)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                              _createElementVNode("ul", _hoisted_28, [
                                                _createVNode(_component_router_link, {
                                                  to: "/admin",
                                                  custom: ""
                                                }, {
                                                  default: _withCtx(({ href, navigate }) => [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("a", {
                                                        href: href,
                                                        onClick: navigate,
                                                        class: "uk-navbar-nav_a"
                                                      }, "Admin", 8, _hoisted_29)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                (_ctx.canAccessAdmin)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createVNode(_component_router_link, {
                                        to: "/admin",
                                        custom: ""
                                      }, {
                                        default: _withCtx(({ href, navigate }) => [
                                          _createElementVNode("a", {
                                            href: href,
                                            onClick: navigate,
                                            class: "uk-navbar-nav_a tw-inline-flex tw-w-full"
                                          }, "Admin", 8, _hoisted_31)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/",
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate }) => [
                        _createElementVNode("li", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, [
                          _createElementVNode("a", {
                            href: href,
                            onClick: navigate,
                            class: "tw-inline-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-p-0 tw-cursor-pointer hover:tw-bg-slate-900/5",
                            "aria-label": "Logout",
                            title: "Logout"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "right-from-bracket",
                              class: "tw-h-4 tw-w-4 tw-text-slate-700 tw-transition-colors hover:tw-text-slate-900 tw-cursor-pointer"
                            })
                          ], 8, _hoisted_32)
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: "/login",
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isActive }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass({ 'uk-active': isActive })
                        }, [
                          _createElementVNode("a", {
                            href: href,
                            onClick: navigate,
                            class: "uk-navbar-nav_a"
                          }, "Login", 8, _hoisted_33)
                        ], 2)
                      ]),
                      _: 1
                    }))
              ])
            ], 2)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { onLogIn: _ctx.logIn }, null, 8, ["onLogIn"])
  ]))
}